import React from 'react'

interface UnionUpProps {
  color?: string
}

const UnionUp = ({ color = '#F36464' }: UnionUpProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="10"
      viewBox="0 0 9 10"
      fill="none"
    >
      <path
        d="M4.89911 0.197367C4.66338 -0.065789 4.22551 -0.065789 3.98978 0.197367L0.135818 4.49963C-0.181235 4.85357 0.0921969 5.38755 0.590483 5.38755H2.67636V9.45736C2.67636 9.75705 2.94023 10 3.26572 10H5.62317C5.94866 10 6.21253 9.75705 6.21253 9.45736V5.38755H8.29841C8.79669 5.38755 9.07012 4.85356 8.75307 4.49963L4.89911 0.197367Z"
        fill={color}
      />
    </svg>
  )
}

export default UnionUp
